import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Footer from '../footer/footer'
import ContentWrapper from '../shared/content-wrapper'
import MainMenu from '../menus/main-menu'
import UserMenu from '../menus/user-menu'
import NotificationFactory from '../../services/notification/notification-factory'
import AlertFactory from '../../services/notification/alert-factory'
import Header from '../header/header'
import CurrentBids from '../views/current-bids'
import Loading from '../views/loading'
import enhanceHeader from '../../services/layout/header-context'
import withMainMenuItems from '../../services/layout/MainMenu'
import withUserMenuItems from '../../services/layout/UserMenu'
import enhanceLayout from '../../services/layout/layout-context'
import enhanceCurrentBids from '../../services/bid/current-bids'

const HeaderWithData = enhanceHeader(Header)
const CurrentBidsPanel = enhanceCurrentBids(CurrentBids)
const MainMenuWithItems = withMainMenuItems(MainMenu)
const UserMenuWithItems = withUserMenuItems(UserMenu)

export const Layout = props => (
  <div
    className={classNames({
      'app-wrapper': true,
      'open-main-menu': props.isMainMenuOpen,
      'open-user-menu': props.isUserMenuOpen,
      [props.className]: props.className,
      [props.theme]: true
    })}
  >
    <MainMenuWithItems onItemClick={props.toggleMainMenu} />
    <UserMenuWithItems
      userName={props.userName}
      onItemClick={props.toggleUserMenu}
      onLogoutClick={props.onLogoutClick}
    />
    <div className='main-content-wrapper'>
      <HeaderWithData
        onMainMenuClick={props.toggleMainMenu}
        onUserMenuClick={props.toggleUserMenu}
      />
      <ContentWrapper>
        <div className='content'>
          <CurrentBidsPanel isOpen={props.isCurrentBidsOpen} />
          <AlertFactory />
          {props.isLoading ? <Loading /> : props.children}
        </div>
        <Footer />
      </ContentWrapper>
      <NotificationFactory />
    </div>
  </div>
)

Layout.propTypes = {
  theme: PropTypes.oneOf(['gradient-theme', 'dark-theme', 'light-theme']),
  isLoading: PropTypes.bool,
  userName: PropTypes.string,
  isMainMenuOpen: PropTypes.bool,
  isUserMenuOpen: PropTypes.bool,
  isCurrentBidsOpen: PropTypes.bool,
  toggleMainMenu: PropTypes.func,
  toggleUserMenu: PropTypes.func,
  onLogoutClick: PropTypes.func
}

Layout.defaultProps = {
  theme: 'dark-theme',
  isLoading: false,
  userName: 'Michael Jordan'
}

export default enhanceLayout(Layout)



// WEBPACK FOOTER //
// ./src/ui/shared/layout.js